export class CreditNoteDto {
	public id: number = 0;
	public amount: number = 0;
	public reason: string = "";
	public createdAt: Date = new Date();
	public customerId: number = 0;
	public customerName: string = "";
	public invoiceId: number | null = null;
	public createdFromCustomerOrderId: number | null = null;
	public deletedAt: Date | null = null;
	public deleteReason: string = "";
}
